<span class="wrapper">
  @if (value === MarkedStatus.SOME) {
    <span class="some-marked-indicator">-</span>
  }
  <mat-checkbox [(ngModel)]="checkboxValue" (ngModelChange)="onCheckboxClick($event)"></mat-checkbox>
</span>
